const servicesPrefixes = {
  account: "ACCOUNT:",
  chat: "CHAT:",
  prompt: "PROMPT:",
  rum: "RUM:",
  agent: "AGENT:",
  analytics: "ANALYTICS:",
  knowledge: "KNOWLEDGE:",
  organization: "ORGANIZATION:",
  promptGuidance: "PROMPTGUIDANCE:",
  group: "GROUP:",
  user: "USER:",
  raiMetrics: "RAIMETRICS:",
  performance: "PERFORMANCE:",
  master: "MASTER:"
};

export const queryKeys = {
  authentication: {
    login: servicesPrefixes.account + "LOGIN",
    logout: servicesPrefixes.account + "LOGOUT",
    refreshToken: servicesPrefixes.account + "REFRESH_TOKEN",
  },
  chats: {
    send: servicesPrefixes.chat + "CHAT_SEND",
    generateTitle: servicesPrefixes.chat + "CHAT_GENERATE_TITLE",
    list: servicesPrefixes.chat + "CHAT_LIST",
    getById: servicesPrefixes.chat + "GET_CHAT_BY_ID",
    deleteChatById: servicesPrefixes.chat + "DELETE_CHAT_BY_ID",
    getPromtList: servicesPrefixes.chat + "FETCH_PROMPTS",
    getKnowledgeBasis: servicesPrefixes.chat + "FETCH_KNOWLEDGE_BASIS",
    sendFeedback: servicesPrefixes.chat + "GIVE_FEEDBACK",
    getAgents: servicesPrefixes.chat + "GET_AGENTS",
    sendMessage: servicesPrefixes.chat + "SEND_MESSAGE",
    conversationHistory: servicesPrefixes.chat + "COVERSATION_HISTORY",
    chatTitle: servicesPrefixes.chat + "CHAT_TITLE",
    getConversation: servicesPrefixes.chat + "GET_CONVERSATION",
    deleteConversation: servicesPrefixes.chat + "DELETE_CONVERSATION",
    fetchFeedback: servicesPrefixes.chat + "GET_FEEDBACK",
    updateFeedback: servicesPrefixes.chat + "UPDATE_FEEDBACK",
  },
  userAdoptionInsights: {
    liveUsers: servicesPrefixes.rum + "LIVE_USERS",
    liveQueries: servicesPrefixes.rum + "LIVE_QUERIES",
    peakUsers: servicesPrefixes.rum + "PEAK_USERS",
    peakQueries: servicesPrefixes.rum + "PEAK_QUERIES",
    totalUsers: servicesPrefixes.rum + "TOTAL_USERS",
    failedResponses: servicesPrefixes.rum + "FAILED_RESPONSES",
    successRequests: servicesPrefixes.rum + "SUCCESS_REQUESTS",
    liveUsersHourly: servicesPrefixes.rum + "LIVE_USERS_HOURLY",
    liveQueriesHourly: servicesPrefixes.rum + "LIVE_QUERIES_HOURLY",
    avgDailyUsers: servicesPrefixes.rum + "AVG_DAILY_USERS",
    avgDailyQueries: servicesPrefixes.rum + "AVG_DAILY_QUERIES",
    zoneWiseActiveUsers: servicesPrefixes.rum + "ZONE_WISE_ACTIVE_USERS",
    verticalWiseActiveUsers:
      servicesPrefixes.rum + "VERTICAL_WISE_ACTIVE_USERS",
    avgEngagementTime: servicesPrefixes.rum + "AVG_ENGAGEMENT_TIME",
    scaleWiseActiveUsers: servicesPrefixes.rum + "SCALE_WISE_ACTIVE_USERS",
    getInsights: servicesPrefixes.rum + "GET_INSIGHTS",
  },
  agent: {
    list: servicesPrefixes.agent + "AGENT_LIST",
    details: servicesPrefixes.agent + "AGENT_DETAILS",
    add: servicesPrefixes.agent + "ADD_AGENT",
    update: servicesPrefixes.agent + "UPDATE_AGENT",
    delete: servicesPrefixes.agent + "DELETE_AGENT",
  },
  promptTemplate: {
    add: servicesPrefixes.chat + "ADD_TEMPLATE",
    edit: servicesPrefixes.chat + "EDIT_TEMPLATE",
    delete: servicesPrefixes.chat + "DELETE_TEMPLATE",
    get: servicesPrefixes.chat + "GET_TEMPLATE",
    versions: servicesPrefixes.chat + "VERSION"
  },
  queryLibrary: {
    create: servicesPrefixes.prompt + "CREATE_QUERY_LIBRARY",
    list: servicesPrefixes.prompt + "LIST_QUERY_LIBRARY",
    getById: servicesPrefixes.prompt + "GET_QUERY_LIBRARY",
    update: servicesPrefixes.prompt + "UPDATE_QUERY_LIBRARY",
    delete: servicesPrefixes.prompt + "DELETE_QUERY_LIBRARY",
  },
  analytics: {
    getAnalytics: servicesPrefixes.analytics + "GET_ANALYTICS",
  },
  knowledge: {
    list: servicesPrefixes.knowledge + "KNOWLEDGE_LIST",
    get: servicesPrefixes.knowledge + "GET_KNOWLEDGE",
    delete: servicesPrefixes.knowledge + "DELETE_KNOWLEDGE",
    create: servicesPrefixes.knowledge + "CREATE_KNOWLEDGE",
    update: servicesPrefixes.knowledge + "UPDATE_KNOWLEDGE",
    summarize: servicesPrefixes.knowledge + "SUMMARIZE_KNOWLEDGE",
    files: servicesPrefixes.knowledge + "KNOWLEDGE_FILES",
  },
  organization: {
    list: servicesPrefixes.organization + "ORG_LIST",
    create: servicesPrefixes.organization + "ORG_CREATE",
    delete: servicesPrefixes.organization + "ORG_DELETE",
    update: servicesPrefixes.organization + "ORG_UPDATE",
    get: servicesPrefixes.organization + "ORG_GET",
  },
  promptGuidance: {
    delete: servicesPrefixes.promptGuidance + "PROMPT_GUIDANCE_DELETE",
    create: servicesPrefixes.promptGuidance + "PROMPT_GUIDANCE_CREATE",
    get: servicesPrefixes.promptGuidance + "PROMPT_GUIDANCE_GET",
    update: servicesPrefixes.promptGuidance + "PROMPT_GUIDANCE_UPDATE",
  },
  group: {
    list: servicesPrefixes.group + "GROUP_LIST",
    create: servicesPrefixes.group + "GROUP_CREATE",
    delete: servicesPrefixes.group + "GROUP_DELETE",
    update: servicesPrefixes.group + "GROUP_UPDATE",
    get: servicesPrefixes.group + "GROUP_GET",
    addUser: servicesPrefixes.group + "ADD_USER_GROUP",
    removeUser: servicesPrefixes.group + "REMOVE_USER_GROUP",
  },
  user: {
    list: servicesPrefixes.user + "LIST_USERS",
    getGroup: servicesPrefixes.user + "GET_GROUP",
    create: servicesPrefixes.user + "CREATE_USER",
    get: servicesPrefixes.user + "GET_USER",
    update: servicesPrefixes.user + "UPDATE_USER",
    delete: servicesPrefixes.user + "DELETE_USER",
  },
  raiMetrics: {
    get: servicesPrefixes.raiMetrics + "GET_RAI_METRICS",
  },
  performance: {
    prometheusQuery: servicesPrefixes.performance + "PROMETHEUS_QUERY",
    performanceEvaluation: servicesPrefixes.performance + "PERFORMANCE_EVALUATION"
  },
  master: {
    get: servicesPrefixes.master + "GET_MASTER_DATA",
  }
};
